import React, { useEffect, useRef, useState } from "react";
import "../Pages/State-Distributor/Orders/Orders.css";
import logo from "../assets/images/signinLogo.png";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import invoiceImg from "../assets/images/State-Distributor/viewInvoice.png";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { Link, useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";
import { axiosInstance } from "../axiosInstance";
import html2pdf from "html2pdf.js";
import { FaArrowLeftLong } from "react-icons/fa6";

export const DistributorViewInvoice = () => {
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const { Id } = location.state || "";
  console.log("ID", Id);

  const [invoiceData, setInvoiceData] = useState({});
  const [tableDetails, setTableDetails] = useState([]);
  // show discount in table only discount is greater than 0
  const hasDiscount = tableDetails?.some((row) => Number(row.discount) > 0);
  async function FetchInvoiceDetails() {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `/distributor/order-invoice-details/${Id}/`,
      );
      if (response.data.status === "success" || response.status === 200) {
        setInvoiceData(response.data?.data);
        setTableDetails(response.data?.data?.order_items);
        console.log("Invoice details fetched successfully!");
      }
    } catch (error) {
      toast.error(
        error.response.data.message || "Failed to fetch invoice details",
      );
      console.log("Failed to fetch invoice details");
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    FetchInvoiceDetails();
  }, []);

  // const pdfRef = useRef();
  // // Download handler
  // const handleDownload = async () => {
  //   const input = pdfRef.current;
  //   if (!input) return;

  //   try {
  //     setLoading(true);
  //     const canvas = await html2canvas(input, {
  //       scale: 2,
  //     });

  //     const imgData = canvas.toDataURL("image/png");

  //     const pdf = new jsPDF("p", "mm", "a4");
  //     const pdfWidth = pdf.internal.pageSize.getWidth();
  //     const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

  //     pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
  //     pdf.save("invoice.pdf");
  //   } catch (err) {
  //     console.error("Download error:", err);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  async function handleDownload() {
    try {
      setLoading(true);

      const response = await axiosInstance.get(`/invoice-pdf/${Id}/`, {
        responseType: "blob", // Required
      });

      if (response.status === 200) {
        const blob = new Blob([response.data], { type: "application/pdf" });

        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        // Try server-provided filename
        const contentDisposition = response.headers["content-disposition"];
        let fileName = "invoice.pdf";
        // let fileName;
        if (contentDisposition) {
          const match = contentDisposition.match(/filename="?(.+)"?/);
          if (match && match[1]) fileName = match[1];
        }

        // Trigger download
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();

        link.remove();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      // toast.error(error?.response?.data?.message || "Unable to download");

      // console.error("Download error:", error);
      let errorMessage = "Unable to download";

      if (error.response && error.response.data) {
        const data = error.response.data;

        if (data instanceof Blob) {
          // If backend sent JSON in blob (common for errors)
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const json = JSON.parse(reader.result);
              toast.error(json.message || errorMessage);
            } catch {
              toast.error(errorMessage);
            }
          };
          reader.readAsText(data);
        } else if (data.message) {
          toast.error(data.message);
        } else {
          toast.error(errorMessage);
        }
      } else {
        toast.error(errorMessage);
      }

      console.error("Download error:", error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            zIndex: 9999,
          }}
        >
          <Stack spacing={2} direction="row" alignItems="center">
            <CircularProgress size={40} sx={{ color: "var(--color-theme)" }} />
          </Stack>
        </div>
      )}
      <ToastContainer />
      <div>
        <div className="btnBack">
          <Link to="/state-invoice">
            <span className="me-1">
              <FaArrowLeftLong />
            </span>
            Back
          </Link>
        </div>
        <div className="newInvoiceContainer">
          <div className="newInvoiceGrid">
            <div>
              <div className="brandTitle">{invoiceData?.user?.username}</div>
              <div className="brandAddress">
                <div>
                  {invoiceData?.user?.hno ?? "---"}, &nbsp;
                  {invoiceData?.user?.street ?? "---"}, &nbsp;
                  {invoiceData?.user?.city ?? "---"}, &nbsp;
                  {invoiceData?.user?.district ?? "---"}, &nbsp;
                  {invoiceData?.user?.state ?? "---"}, &nbsp;
                  {invoiceData?.user?.pincode ?? "---"}
                </div>
                <div>{invoiceData?.user?.phone_number ?? "---"}</div>
              </div>
              <div className="gstContainer">
                <div className="gstSub">
                  <span>GSTIN :</span>
                  <span>{invoiceData?.user?.gstin ?? "---"}</span>
                </div>
                <div className="gstSub">
                  <span>State :</span>
                  <span>{invoiceData?.user?.state ?? "---"}</span>
                </div>
                <div className="gstSub">
                  <span>State Code :</span>
                  <span>{invoiceData?.user?.state_code ?? "---"}</span>
                </div>
                <div className="gstSub">
                  <span>Invoice Number :</span>
                  <span>{invoiceData?.invoice_number ?? "---"}</span>
                </div>
                <div className="gstSub">
                  <span>Invoice Date :</span>
                  <span>
                    {invoiceData?.invoice_date
                      ? new Date(invoiceData.invoice_date).toLocaleDateString(
                          "en-GB",
                        )
                      : "---"}
                  </span>
                </div>
              </div>
            </div>
            <div className="invoiceLogoImg">
              <img src={invoiceData?.distributor_company_logo} alt="logo_img" />

              {/* <img src={logoBase64 || invoiceImg} /> */}
            </div>
          </div>
          <div className="mainAddressContainer">
            <div>
              <div className="textBillTo">Bill To :</div>
              <div className="ownerTitle">
                {invoiceData?.customer_name ?? "---"}
              </div>
              <div className="billAddress">{invoiceData?.address ?? ""}</div>
              <div className="billAddress">
                {invoiceData?.phone_number ?? ""}
              </div>
              <div className="gstContainer">
                <div className="gstSub">
                  <span>GSTIN :</span>
                  <span>{invoiceData?.gstin ?? "---"}</span>
                </div>
                <div className="gstSub">
                  <span>State :</span>
                  <span>{invoiceData?.state ?? "---"}</span>
                </div>
                <div className="gstSub">
                  <span>State Code :</span>
                  <span>{invoiceData?.state_code ?? "---"}</span>
                </div>
                <div className="gstSub">
                  <span>Pin Code :</span>
                  <span>{invoiceData?.pincode ?? "---"}</span>
                </div>
                <div className="gstSub">
                  <span>PAN :</span>
                  <span>{invoiceData?.pan_number ?? "---"}</span>
                </div>
              </div>
            </div>
            <div>
              <div>
                <div className="textBillTo">Ship To :</div>
                <div className="ownerTitle">
                  {invoiceData?.shipping_name ?? "---"}
                </div>
                <div className="billAddress">
                  {invoiceData?.shipping_address ?? "---"}
                </div>
                <div className="billAddress">
                  {invoiceData?.shipping_phone ?? ""}
                </div>
                <div className="gstContainer">
                  {/* <div className="gstSub">
                    <span>GSTIN :</span>
                    <span>{invoiceData?.gstin ?? "---"}</span>
                  </div> */}
                  <div className="gstSub">
                    <span>State :</span>
                    <span>{invoiceData?.shipping_state ?? "---"}</span>
                  </div>
                  <div className="gstSub">
                    <span>State Code :</span>
                    <span>{invoiceData?.shipping_state_code ?? "---"}</span>
                  </div>
                  <div className="gstSub">
                    <span>Pin Code :</span>
                    <span>{invoiceData?.shipping_pincode ?? "---"}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="dashboardTableContainer">
            <TableContainer component={Paper} className="invoiceTable">
              <Table
                sx={{ minWidth: 650 }}
                //  sx={{ minWidth: 1200}}
                stickyHeader
                aria-label="sticky table"
              >
                <TableHead className="dashboadTableHeader">
                  <TableRow>
                    {/* <TableCell>Product Code</TableCell> */}
                    <TableCell align="left">S.No</TableCell>
                    <TableCell align="left">Product Name</TableCell>
                    {/* <TableCell align="left">UOM</TableCell> */}
                    <TableCell align="left">Package Size</TableCell>
                    <TableCell align="left">HSN Code</TableCell>
                    <TableCell align="left">Qty</TableCell>
                    <TableCell align="left">Price/Unit (₹)</TableCell>
                    {/* <TableCell align="left">Total Price</TableCell> */}
                    <TableCell align="left">GST %</TableCell>
                    {/* <TableCell align="left">CGST + SGST</TableCell> */}
                    {/* <TableCell align="left">Total After Tax</TableCell> */}
                    {hasDiscount && (
                      <TableCell align="left">Discount</TableCell>
                    )}
                    <TableCell align="left">Final Total</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tableDetails?.length > 0 ? (
                    tableDetails?.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                        className="dashboardTableBody"
                      >
                        {/* <TableCell align="left">
                          {row.product_code || "---"}
                        </TableCell> */}
                        <TableCell align="left">{index + 1}</TableCell>
                        <TableCell align="left">
                          {row.product_name || "---"}{" "}
                          <span>{`(${row.variant})`}</span>
                        </TableCell>

                        {/* <TableCell align="left">{row.uom || "---"}</TableCell> */}
                        <TableCell align="left">
                          {row.package_size || "---"}
                        </TableCell>
                        <TableCell align="left">
                          {row.hs_code || "---"}
                        </TableCell>
                        <TableCell align="left">{row.qty || 0}</TableCell>
                        <TableCell align="left">{row.price || 0}</TableCell>
                        {/* <TableCell align="left">{row.total || 0}</TableCell> */}
                        <TableCell align="left">{row.gst || 0}%</TableCell>
                        {/* <TableCell align="left">{row.cgst_sgst || 0}</TableCell> */}
                        {/* <TableCell align="left">
                          {row.total_after_tax || 0}
                        </TableCell> */}
                        {hasDiscount && (
                          <TableCell align="left">
                            {row.discount ?? 0}%
                          </TableCell>
                        )}

                        <TableCell align="left">{row.final || 0}</TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell align="center" colSpan={8}>
                        Data not available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
          {/* bank and total table  */}
          <div className="InvoiceContainer">
            <TableContainer component={Paper} className="invoiceTable">
              <Table
                // sx={{ minWidth: 650 }}
                aria-label="simple table"
              >
                <TableBody>
                  {invoiceData?.user &&
                  Object.keys(invoiceData?.user).length > 0 ? (
                    <>
                      {/* <TableRow>
                        <TableCell sx={{ fontWeight: "bold" }}>
                          Total Payment
                        </TableCell>
                        <TableCell align="left">
                          {rows2.product || "---"}
                        </TableCell>
                      </TableRow> */}

                      <TableRow>
                        <TableCell sx={{ fontWeight: "bold" }}>
                          GPay Number
                        </TableCell>
                        <TableCell align="left">
                          {invoiceData?.user?.google_pay_number || "---"}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontWeight: "bold" }}>
                          PhonePe Number
                        </TableCell>
                        <TableCell align="left">
                          {invoiceData?.user?.phone_pay_number || "---"}
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell sx={{ fontWeight: "bold" }}>
                          Account No
                        </TableCell>
                        <TableCell align="left">
                          {invoiceData?.user?.account_number || "---"}
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell sx={{ fontWeight: "bold" }}>
                          IFSC Code
                        </TableCell>
                        <TableCell align="left">
                          {invoiceData?.user?.ifsc_code || "---"}
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell sx={{ fontWeight: "bold" }}>
                          Branch
                        </TableCell>
                        <TableCell align="left">
                          {invoiceData?.user?.branch_name || "---"}
                        </TableCell>
                      </TableRow>
                    </>
                  ) : (
                    <TableRow>
                      <TableCell align="center" colSpan={2}>
                        Data not available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            <TableContainer component={Paper} className="invoiceTable">
              <Table
                // sx={{ minWidth: 650 }}
                aria-label="vertical table"
              >
                {/* <TableBody>
                  {tableDetails?.length > 0 ? (
                    tableDetails.map((row, index) => (
                      <React.Fragment key={index}>
                        <TableRow>
                          <TableCell sx={{ fontWeight: "bold", width: "40%" }}>
                            Total Products (Qty):
                          </TableCell>
                          <TableCell align="left">{row.qty || "---"}</TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell sx={{ fontWeight: "bold" }}>
                            Total Price
                          </TableCell>
                          <TableCell align="left">{row.price}</TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell sx={{ fontWeight: "bold" }}>
                            Tax Amount
                          </TableCell>
                          <TableCell align="left">
                            {row.total || "---"}
                          </TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell sx={{ fontWeight: "bold" }}>
                            Total After Tax
                          </TableCell>
                          <TableCell align="left">
                            {row.total_after_tax}
                          </TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell sx={{ fontWeight: "bold" }}>
                            Discount
                          </TableCell>
                          <TableCell align="left">{row.discount}</TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell sx={{ fontWeight: "bold" }}>
                            Final Total
                          </TableCell>
                          <TableCell align="left">{row.final}</TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell sx={{ fontWeight: "bold" }}>
                            Payment Status
                          </TableCell>
                          <TableCell align="left">
                            {row.payment_status ?? "---"}
                          </TableCell>
                        </TableRow>
                      </React.Fragment>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell align="center" colSpan={2}>
                        Data not available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody> */}
                <TableBody>
                  {
                    <React.Fragment>
                      <TableRow>
                        <TableCell sx={{ fontWeight: "bold", width: "40%" }}>
                          Total Products (Qty):
                        </TableCell>
                        <TableCell align="left">
                          {invoiceData?.total_qty || 0}
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell sx={{ fontWeight: "bold" }}>
                          Total Price
                        </TableCell>
                        <TableCell align="left">
                          {invoiceData?.total_price || 0}
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell sx={{ fontWeight: "bold" }}>
                          Tax Amount
                        </TableCell>
                        <TableCell align="left">
                          {invoiceData?.total_tax || 0}
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell sx={{ fontWeight: "bold" }}>
                          Total After Tax
                        </TableCell>
                        <TableCell align="left">
                          {invoiceData?.total_after_tax || 0}
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell sx={{ fontWeight: "bold" }}>
                          Total Discount Amount
                        </TableCell>
                        <TableCell align="left">
                          {invoiceData?.total_discount_amount}
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell sx={{ fontWeight: "bold" }}>
                          Final Total
                        </TableCell>
                        <TableCell align="left">
                          {invoiceData?.final_total || 0}
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell sx={{ fontWeight: "bold" }}>
                          Payment Status
                        </TableCell>
                        <TableCell align="left">
                          {invoiceData?.payment_status ?? "---"}
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  }
                </TableBody>
              </Table>
            </TableContainer>
          </div>
          {/* qr code  */}
          <div className="qrContainer">
            <div className="qrSub">
              <div>
                <div>Please make payment within 15 days.</div>
                <div>For any query contact us at:</div>
                <div>
                  Mobile :{" "}
                  <span style={{ color: "#414652" }}>
                    {invoiceData?.user?.phone_number ?? "---"}
                  </span>
                </div>
                <div>
                  Email :{" "}
                  <span style={{ color: "#414652" }}>
                    {invoiceData?.user?.email ?? "---"}
                  </span>
                </div>
              </div>
              <div className="qrImg">
                <div>Scan to pay with QR code</div>
                <img
                  src={invoiceData?.user?.qr_code || invoiceImg}
                  alt="qr_img"
                />
                {/* <img src={qrBase64 ||  invoiceImg} /> */}
              </div>
            </div>
            <div>
              <div>Terms & Conditions</div>
              <div>
                <textarea
                  disabled
                  rows={4}
                  value={invoiceData?.user?.terms_and_conditions || "---"}
                ></textarea>
              </div>
            </div>
          </div>
          {/* certified text */}
          <div className="certifiedContainer">
            <div>
              Certified that the particulars given above are true and correct.
            </div>
            <div className="mb-4">For TRADE VIBE GLOBAL</div>
            <div>
              This is a System Generated Invoice. Signature is not required.
            </div>
            <div>Subject to Hyderabad Jurisdiction [E & OE]</div>
          </div>
        </div>
        {/* buttons  */}
        <div className="btnDownloadInvoice">
          <button onClick={handleDownload}>Download Invoice</button>
        </div>
      </div>
    </>
  );
};
